import { Col, Form, Input, Row } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

import StrongPass from '../../../../../components/StrongPassword';
import SubHeader from '../../../../../components/SubHeader';

export default function FormDadosAcesso({
  isEditing,
  setIsValidPassword,
  setPass,
  isRequiredPassword,
}) {
  const renderColLogin = () => (
    <Col xs={12} lg={12} xl={12}>
      <Form.Item
        name="login"
        rules={[
          {
            required: isEditing,
            message: 'Por favor, insira um login!',
          },
          {
            pattern: /^[^\\:]*$/,
            message: 'O caracter dois pontos não é aceito neste cadastro',
          },
        ]}
        label="Login"
        labelAlign="right"
        labelCol={{ xl: { span: 4 }, lg: { span: 5 } }}
      >
        <Input className="total-width" disabled={!isEditing} />
      </Form.Item>
    </Col>
  );

  const renderColCurrentPass = () => (
    <Col span={12}>
      <Form.Item
        name="currentPass"
        rules={[
          {
            required: isRequiredPassword,
            message: 'Por favor, insira a senha atual!',
          },
        ]}
        label="Senha atual"
        labelAlign="right"
        labelCol={{ xl: { span: 5 }, lg: { span: 5 } }}
      >
        <Input.Password className="total-width" disabled={!isEditing} />
      </Form.Item>
    </Col>
  );

  const renderColInputNewPass = () => (
    <Col xs={12} lg={12} xl={12}>
      <StrongPass
        requisitos={['M', 'm', '9']}
        setIsValidPass={setIsValidPassword}
        setPass={setPass}
        required={isRequiredPassword}
        disabled={!isEditing}
        formProps={Form.Item}
        labelCol={{ xl: { span: 5 }, lg: { span: 6 } }}
        labelAlign="right"
        label="Nova senha"
      />
    </Col>
  );

  const renderColPassConfirm = () => (
    <Col xs={12} lg={12} xl={12}>
      <Form.Item
        name="passConfirm"
        rules={[
          {
            required: isRequiredPassword,
            message: 'Por favor, confirme a senha!',
          },
        ]}
        label="Confirmar senha"
        labelAlign="right"
        labelCol={{ xl: { span: 6 }, lg: { span: 6 } }}
      >
        <Input.Password
          className="total-width"
          autoComplete="new-password"
          disabled={!isEditing}
        />
      </Form.Item>
    </Col>
  );

  return (
    <div className="mt-10">
      <SubHeader title="Alterar Login" />
      <Row gutter={12} className="mb-10">
        {renderColLogin()}
      </Row>

      <SubHeader title="Alterar Senha" />
      <Col gutter={12}>
        {renderColCurrentPass()}
        {renderColInputNewPass()}
        {renderColPassConfirm()}
      </Col>
    </div>
  );
}

FormDadosAcesso.propTypes = {
  isEditing: PropTypes.bool,
  setIsValidPassword: PropTypes.func,
  setPass: PropTypes.func,
  isRequiredPassword: PropTypes.bool,
};

FormDadosAcesso.defaultProps = {
  isEditing: false,
  setIsValidPassword: null,
  setPass: null,
  isRequiredPassword: false,
};
